var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userProfile)?_c('div',[(_vm.userProfile.tenantId === 'root')?_c('AdminLayout',{attrs:{"userProfile":_vm.userProfile}}):_c('EndUserLayout',{attrs:{"userProfile":_vm.userProfile}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }